import * as firebase from 'firebase/app';
import 'firebase/firestore';

export class BaseDatabaseService {

  protected static RUN_LOCAL = false;

  protected db;
  protected functions;

  constructor() {
    if (!firebase.apps.length) {
      firebase.initializeApp({
        apiKey: 'AIzaSyB6bfEK5WB4NLJA3m0JaVrWQgaJzIHixr4',
        authDomain: 'time4race-6be4a.firebaseapp.com',
        projectId: 'time4race-6be4a'
      });
    }

    this.db = firebase.firestore();
    this.functions = firebase.functions();
  }

  public static toArray(data) {
    const arr = [];
    data.forEach(item => {
      const racer = item.data();
      racer.id = item.id;
      arr.push(racer);
    });
    return arr;
  }
}
